import { render, staticRenderFns } from "./Taked.vue?vue&type=template&id=6a90b127&scoped=true&"
import script from "./Taked.vue?vue&type=script&lang=js&"
export * from "./Taked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90b127",
  null
  
)

export default component.exports